import { createAction } from '@reduxjs/toolkit';

const createAppAction = <T>(actionType: string) => createAction<T>(`app/${actionType}`);

export const waitForModerator = createAppAction('waitForModerator');
export const meetingStartedAlready = createAppAction('meetingStartedAlready');
export const joinAsGuestRequest = createAppAction<void>('JoinAsGuestRequest');
